import http from "../../http-common";

const getAll = async () => {
  return await http
    .get("/ultimate/features")
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const getById = async (id) => {
  return await http
    .get(`/ultimate/features/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const create = async (feature) => {
  return await http
    .post("/ultimate/features", feature)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const update = async (feature) => {
  return await http
    .put(`/ultimate/features/${feature.id}`, feature)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const remove = async (id) => {
  return await http
    .delete(`/ultimate/features/${id}`)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const uploadScreenshot = async (id, file) => {
  const formData = new FormData();
  formData.append("file", file);
  return await http
    .post(`/ultimate/features/${id}/screenshots`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const aiChatRequest = async (body) => {
  return await http
    .post("/ultimate/features/ai-chat", body)
    .then((r) => r.data)
    .catch((error) => {
      throw error.response?.data || error.response || error;
    });
};

const aiChatStart = async ({ brief, context }) =>
  aiChatRequest({ action: "start", brief, context });

const aiChatAnswer = async ({ sessionId, answers }) =>
  aiChatRequest({ action: "answer", sessionId, answers });

const aiChatSkip = async ({ sessionId }) =>
  aiChatRequest({ action: "skip", sessionId });

const aiChatRefine = async ({ sessionId, feedback }) =>
  aiChatRequest({ action: "refine", sessionId, feedback });

export default {
  getAll,
  getById,
  create,
  update,
  remove,
  uploadScreenshot,
  aiChatStart,
  aiChatAnswer,
  aiChatSkip,
  aiChatRefine,
};
